export function enhanceForSearchableSelect(salesforceAccount) {
  return {
    ...salesforceAccount,
    readableKey: `${salesforceAccount.accountName} - ${salesforceAccount.id}`,
  };
}

// Take the id from the readableKey
export function substringId(salesforceAccountSelect) {
  const regex = /.+ - (.{18})$/;
  const match = regex.exec(salesforceAccountSelect);
  if (match) {
    return match[1];
  }

  return salesforceAccountSelect;
}
